// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"T","headerWrapper":"U","iconButton":"V","icon":"W","header":"X","subHeader":"Y","description":"Z","inputWrapper":"aa","buttonWrapper":"ab","warning":"ac"};